var _excluded = ["isLoading", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useImperativeHandle } from 'react';
import { forwardRef, useScrollWidth } from '../../../../../utils';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Blanket } from '../../../../feedback/Blanket';
import { Box } from '../../../Box';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private This is for internal use only.
 */
export var _TableBody = forwardRef((_ref, propRef) => {
  var {
    isLoading,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    ref,
    scrollWidth
  } = useScrollWidth();
  useImperativeHandle(propRef, () => ref.current);
  var style = useMultiStyleConfig('Table', {
    tableWidth: scrollWidth,
    isLoading
  });
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    role: "rowgroup",
    "data-component": "TableBody",
    __css: style['tableBody']
  }, props), {}, {
    ref: ref,
    children: isLoading ? /*#__PURE__*/_jsx(Box, {
      __css: style['loaderContainer'],
      children: /*#__PURE__*/_jsx(Blanket, {
        isOpen: true,
        variant: "light",
        isLoading: true
      })
    }) : children
  }));
});
_TableBody.displayName = 'TableBody';
//# sourceMappingURL=_TableBody.js.map